// Fragment "modals (lot F)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    "payments.title": "Paiements marketplace",
    "payments.subtitle": "Encaissements Stripe (cours & consultations) — commission Solunary prélevée automatiquement.",
    "payments.empty": "Aucun paiement marketplace pour le moment.",
    "payments.commission": "commission",
    "payments.confirmRefund": "Rembourser {amount} {currency} ?",
    "payments.toast.refunded": "Remboursement effectué",
    "payments.toast.refundError": "Remboursement échoué",
    "payments.badgeRefunded": "Remboursé",
    "payments.refundPartial": "Solde",
    "payments.refund": "Rembourser",
  },
  en: {
    "payments.title": "Marketplace payments",
    "payments.subtitle": "Stripe charges (courses & consultations) — Solunary commission deducted automatically.",
    "payments.empty": "No marketplace payments yet.",
    "payments.commission": "commission",
    "payments.confirmRefund": "Refund {amount} {currency}?",
    "payments.toast.refunded": "Refund completed",
    "payments.toast.refundError": "Refund failed",
    "payments.badgeRefunded": "Refunded",
    "payments.refundPartial": "Balance",
    "payments.refund": "Refund",
  },
  es: {
    "payments.title": "Pagos del marketplace",
    "payments.subtitle": "Cobros de Stripe (cursos y consultas) — la comisión de Solunary se descuenta automáticamente.",
    "payments.empty": "Aún no hay pagos del marketplace.",
    "payments.commission": "comisión",
    "payments.confirmRefund": "¿Reembolsar {amount} {currency}?",
    "payments.toast.refunded": "Reembolso realizado",
    "payments.toast.refundError": "Reembolso fallido",
    "payments.badgeRefunded": "Reembolsado",
    "payments.refundPartial": "Saldo",
    "payments.refund": "Reembolsar",
  },
};
